const localeEs = {
  es: {
    TITLE_1: 'Hola,',
    TITLE_2: '¿Qué necesitas hacer hoy?',
    DESCRIPTION:
      'Accede a las principales herramientas para la gestión del talento de tu organización:',

    PERFORMANCE_COMPETENCES_LABEL: 'Desempeño',
    PERFORMANCE_COMPETENCES_TITLE: 'Objetivos y competencias',
    PERFORMANCE_COMPETENCES_DESCRIPTION:
      'Cuantifica el desempeño y el compromiso de los equipos.',
    PERFORMANCE_COMPETENCES_CTA: 'Ver resultados',

    PERFORMANCE_FEEDBACK_LABEL: 'Desempeño',
    PERFORMANCE_FEEDBACK_TITLE: 'Feedback',
    PERFORMANCE_FEEDBACK_DESCRIPTION:
      'Mejora el desempeño de tu equipo con retroalimentación constante.',
    PERFORMANCE_FEEDBACK_CTA: 'Ver resultados',

    PERFORMANCE_PID_LABEL: 'Desempeño',
    PERFORMANCE_PID_TITLE: 'Plan individual de desarrollo',
    PERFORMANCE_PID_DESCRIPTION:
      'Crea procesos para cerrar brechas y promover el Talento Humano.',
    PERFORMANCE_PID_CTA: 'Crear PID',

    CLIMATE_SURVEY_LABEL: 'Clima',
    CLIMATE_SURVEY_TITLE: 'Encuestas',
    CLIMATE_SURVEY_DESCRIPTION:
      'Escucha las necesidades de las personas y crea una mejor cultura.',
    CLIMATE_SURVEY_CTA: 'Monitorear clima',

    CLIMATE_RECOGNITION_LABEL: 'Clima',
    CLIMATE_RECOGNITION_TITLE: 'Reconocimiento',
    CLIMATE_RECOGNITION_DESCRIPTION:
      'Gestiona la cultura del reconocimiento a través de medallas.',
    CLIMATE_RECOGNITION_CTA: 'Ver detalle',

    LEARNING_SKILL_EVOLUTION_LABEL: 'E-Learning',
    LEARNING_SKILL_EVOLUTION_TITLE: 'Skill XP Evolution',
    LEARNING_SKILL_EVOLUTION_DESCRIPTION:
      'Mide las habilidades de tus equipos y detecta áreas de oportunidad y crecimiento.',
    LEARNING_SKILL_EVOLUTION_CTA: 'Ver resultados',

    LEARNING_GROUP_STATISTICS_LABEL: 'E-Learning',
    LEARNING_GROUP_STATISTICS_TITLE: 'Rutas de aprendizaje',
    LEARNING_GROUP_STATISTICS_DESCRIPTION:
      'Analiza el progreso del aprendizaje de los colaboradores.',
    LEARNING_GROUP_STATISTICS_CTA: 'Ver progreso',

    LEARNING_COURSES_LABEL: 'E-Learning',
    LEARNING_COURSES_TITLE: 'Cursos personalizados',
    LEARNING_COURSES_DESCRIPTION:
      'Gestiona el contenido de aprendizaje de tu organización y planifica capacitaciones a la medida.',
    LEARNING_COURSES_CTA: 'Ver detalle',

    CARD_LABEL_1: 'Desempeño',
    CARD_TITLE_1: 'Objetivos y competencias',
    CARD_DESCRIPTION_1:
      'Cuantifica el desempeño y el compromiso de los equipos.',
    CARD_CTA_1: 'Ver resultados',

    CARD_LABEL_2: 'Clima',
    CARD_TITLE_2: 'Encuestas',
    CARD_DESCRIPTION_2:
      'Escucha las necesidades de las personas y crea una mejor cultura.',
    CARD_CTA_2: 'Monitorear clima',

    CARD_LABEL_3: 'E-Learning',
    CARD_TITLE_3: 'Skill XP Evolution',
    CARD_DESCRIPTION_3:
      'Mide las habilidades de tus equipos y detecta áreas de oportunidad y crecimiento.',
    CARD_CTA_3: 'Ver resultados',

    CARD_LABEL_4: 'E-Learning',
    CARD_TITLE_4: 'Rutas de aprendizaje',
    CARD_DESCRIPTION_4:
      'Analiza el progreso del aprendizaje de los colaboradores.',
    CARD_CTA_4: 'Ver progreso',

    CARD_LABEL_5: 'Desempeño',
    CARD_TITLE_5: 'Feedback',
    CARD_DESCRIPTION_5:
      'Mejora el desempeño de tu equipo con retroalimentación constante.',
    CARD_CTA_5: 'Ver resultados',

    CARD_LABEL_6: 'Clima',
    CARD_TITLE_6: 'Reconocimiento',
    CARD_DESCRIPTION_6:
      'Gestiona la cultura del reconocimiento a través de medallas.',
    CARD_CTA_6: 'Ver detalle',

    CARD_LABEL_7: 'Desempeño',
    CARD_TITLE_7: 'Plan individual de desarrollo',
    CARD_DESCRIPTION_7:
      'Crea procesos para cerrar brechas y promover el Talento Humano.',
    CARD_CTA_7: 'Crear PID',

    CARD_LABEL_8: 'E-Learning',
    CARD_TITLE_8: 'Cursos personalizados',
    CARD_DESCRIPTION_8:
      'Gestiona el contenido de aprendizaje de tu organización y planifica capacitaciones a la medida.',
    CARD_CTA_8: 'Ver detalle',

    // Home V2
    HEADER_V2_DESCRIPTION:
      'En este espacio, encontrarás las principales herramientas para tu crecimiento dentro de la compañía.',

    TITLE_1_MOBILE: 'Hola',

    CARDS_ENROLLED_COURSES_TITLE: 'Cursos inscritos',
    CARDS_ENROLLED_COURSES_DESCRIPTION:
      'Ingresa a los cursos que tienes asignados y continua con tu desarrollo.',
    CARDS_ENROLLED_COURSES_CTA: 'Ver mis cursos',
    CARDS_LEARNING_PATHS_TITLE: 'Rutas de aprendizaje',
    CARDS_LEARNING_PATHS_DESCRIPTION:
      'Potencia tus habilidades con contenido especializado y planificado para ti.',
    CARDS_LEARNING_PATHS_CTA: 'Ver mis rutas',

    PROFILE_CARD_VIEW_PROFILE: 'Ver perfil',
    PROFILE_CARD_OCCUPATION: 'Cargo',
    PROFILE_CARD_DEPARTMENT: 'Departamento',
    PROFILE_CARD_BOSS: 'Jefe',
    PROFILE_CARD_LOCATION: 'Sede',

    TALENT_CARD_TITLE: 'Procesos de Talento Humano',
    TALENT_CARD_TITLE_SHORT: 'Procesos de Talent',
    TALENT_CARD_DESCRIPTION:
      'Accede a guías y tutoriales para sacarle el máximo provecho a los cursos y funcionalidades de aprendizaje.',
    GREETINGS: 'Buen día, {{name}}',
    DATE_PREPOSITION_DE: 'de',
    DATE_PREPOSITION_DEL: 'del',
  },
};

export default localeEs;
